





















import { defineComponent } from "@vue/composition-api";
import { FormField, FormFields } from "@/types";
import { formatDate } from "@/lib/helpers/time";
import { TEXT } from "@/lib/const";

export default defineComponent({
  name: "BlockBaseView",
  props: {
    fields: { type: Array as () => FormFields, required: true },
    flexClass: { type: String, default: "col-12 col-md-6 mb-2" },
  },
  methods: {
    getValue(field: FormField) {
      const getText = (value?: string, type?: FormField["type"], list?: FormField["list"]) => {
        if (value === undefined || value === null || value === "") return TEXT.FIELD_EMPTY;
        if (list && (type === "autocomplete" || type === "select")) {
          const listItem = list.find(item => item.value === value);
          return listItem !== undefined && listItem !== null ? listItem.text : TEXT.FIELD_EMPTY;
        }
        if (field.type === "date") return formatDate(value);
        return value;
      };

      if (field.value && Array.isArray(field.value)) {
        return field.value.reduce((out, item) => {
          const result = getText(item, field.type, field.list);
          out += out.length === 0 ? result : `, ${result}`;
          return out;
        }, "");
      }
      return getText(field.value, field.type, field.list);
    },
  },
});
